import { useNavigate } from "react-router-dom";

/** Opens a subject on the Subjects page (/subjects#civics) and scrolls to it, the same way the footer links do. */
const useOpenSubject = () => {
	const navigate = useNavigate();

	return (id) => {
		navigate(`/subjects#${id}`);
		setTimeout(() => {
			const target = document.getElementById(id);
			if (target) target.scrollIntoView({ behavior: "smooth" });
		}, 100);
	};
};

export default useOpenSubject;
